(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './boislocal-platform-platform-infra-commons-commons-domain.js', './boislocal-platform-platform-s2-realization-realization-domain.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'), require('./boislocal-platform-platform-s2-realization-realization-domain.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-realization-query-realization-query-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-f2-realization-query-realization-query-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-realization-query-realization-query-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-f2-realization-query-realization-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-realization-query-realization-query-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-f2-realization-query-realization-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-realization-realization-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-realization-query-realization-query-domain'. Its dependency 'boislocal-platform-platform-s2-realization-realization-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-realization-realization-domain' is loaded prior to 'boislocal-platform-platform-f2-realization-query-realization-query-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-realization-query-realization-query-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-f2-realization-query-realization-query-domain'.");
    }
    root['boislocal-platform-platform-f2-realization-query-realization-query-domain'] = factory(typeof this['boislocal-platform-platform-f2-realization-query-realization-query-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-f2-realization-query-realization-query-domain'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['boislocal-platform-platform-infra-commons-commons-domain'], this['boislocal-platform-platform-s2-realization-realization-domain'], this['fixers-f2-f2-dsl-f2-dsl-cqrs']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_org_boislocal_commons_domain, kotlin_org_boislocal_realization_domain, kotlin_io_komune_f2_f2_dsl_cqrs) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var hasRoles = kotlin_org_boislocal_commons_domain.$_$.l;
  var S2_getInstance = kotlin_org_boislocal_realization_domain.$_$.a;
  var RealizationUpdateCommand = kotlin_org_boislocal_realization_domain.$_$.e;
  var getKClass = kotlin_kotlin.$_$.f;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var RealizationDeleteCommand = kotlin_org_boislocal_realization_domain.$_$.b;
  var RealizationFinishCommand = kotlin_org_boislocal_realization_domain.$_$.c;
  var RealizationUnlockCommand = kotlin_org_boislocal_realization_domain.$_$.d;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var defineProp = kotlin_kotlin.$_$.b9;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(RealizationDTO, 'RealizationDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(RealizationPolicies, 'RealizationPolicies', objectMeta);
  setMetadataFor(RealizationGetQueryDTO, 'RealizationGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(RealizationGetResponseDTO, 'RealizationGetResponseDTO', interfaceMeta);
  setMetadataFor(RealizationPageQueryDTO, 'RealizationPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(RealizationPageResponseDTO, 'RealizationPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function RealizationDTO() {
  }
  function RealizationPolicies() {
  }
  protoOf(RealizationPolicies).canList = function (authedUser) {
    var tmp;
    if (hasRoles(authedUser, ['admin'])) {
      tmp = true;
    } else {
      tmp = hasRole(authedUser, 'admin');
    }
    return tmp;
  };
  protoOf(RealizationPolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(RealizationPolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RealizationUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.RealizationPolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RealizationPolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RealizationDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.RealizationPolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RealizationPolicies).canFinish = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RealizationFinishCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.RealizationPolicies.canFinish.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RealizationPolicies).canUnlock = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RealizationUnlockCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.RealizationPolicies.canUnlock.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var RealizationPolicies_instance;
  function RealizationPolicies_getInstance() {
    return RealizationPolicies_instance;
  }
  function RealizationGetQueryDTO() {
  }
  function RealizationGetResponseDTO() {
  }
  function RealizationPageQueryDTO() {
  }
  function RealizationPageResponseDTO() {
  }
  //region block: init
  RealizationPolicies_instance = new RealizationPolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$realization = $org$boislocal$platform$f2.realization || ($org$boislocal$platform$f2.realization = {});
    var $org$boislocal$platform$f2$realization$query = $org$boislocal$platform$f2$realization.query || ($org$boislocal$platform$f2$realization.query = {});
    var $org$boislocal$platform$f2$realization$query$domain = $org$boislocal$platform$f2$realization$query.domain || ($org$boislocal$platform$f2$realization$query.domain = {});
    var $org$boislocal$platform$f2$realization$query$domain$model = $org$boislocal$platform$f2$realization$query$domain.model || ($org$boislocal$platform$f2$realization$query$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$realization = $org$boislocal$platform$f2.realization || ($org$boislocal$platform$f2.realization = {});
    var $org$boislocal$platform$f2$realization$query = $org$boislocal$platform$f2$realization.query || ($org$boislocal$platform$f2$realization.query = {});
    var $org$boislocal$platform$f2$realization$query$domain = $org$boislocal$platform$f2$realization$query.domain || ($org$boislocal$platform$f2$realization$query.domain = {});
    var $org$boislocal$platform$f2$realization$query$domain$policy = $org$boislocal$platform$f2$realization$query$domain.policy || ($org$boislocal$platform$f2$realization$query$domain.policy = {});
    defineProp($org$boislocal$platform$f2$realization$query$domain$policy, 'RealizationPolicies', RealizationPolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$realization = $org$boislocal$platform$f2.realization || ($org$boislocal$platform$f2.realization = {});
    var $org$boislocal$platform$f2$realization$query = $org$boislocal$platform$f2$realization.query || ($org$boislocal$platform$f2$realization.query = {});
    var $org$boislocal$platform$f2$realization$query$domain = $org$boislocal$platform$f2$realization$query.domain || ($org$boislocal$platform$f2$realization$query.domain = {});
    var $org$boislocal$platform$f2$realization$query$domain$query = $org$boislocal$platform$f2$realization$query$domain.query || ($org$boislocal$platform$f2$realization$query$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$realization = $org$boislocal$platform$f2.realization || ($org$boislocal$platform$f2.realization = {});
    var $org$boislocal$platform$f2$realization$query = $org$boislocal$platform$f2$realization.query || ($org$boislocal$platform$f2$realization.query = {});
    var $org$boislocal$platform$f2$realization$query$domain = $org$boislocal$platform$f2$realization$query.domain || ($org$boislocal$platform$f2$realization$query.domain = {});
    var $org$boislocal$platform$f2$realization$query$domain$query = $org$boislocal$platform$f2$realization$query$domain.query || ($org$boislocal$platform$f2$realization$query$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-f2-realization-query-realization-query-domain.js.map
